import * as Sentry from '@sentry/react'

import { DEFAULT_TAG_COLOR } from './tagging.constants'
import type { TagColor } from './tagging.types'

const TAG_COLOR_MAP: Record<TagColor, { hex: string; border: string }> = {
  blue: { border: '#AFD7FA', hex: '#C7E3FC' },
  gray: { border: '#DEE2E6', hex: '#E9ECEF' },
  green: { border: '#8ECDB5', hex: '#AFDECE' },
  orange: { border: '#F5B94E', hex: '#FDCE84' },
  pink: { border: '#FAACB3', hex: '#FFC7CC' },
  yellow: { border: '#F5E662', hex: '#FAEE82' },
}

const getTagColorEntry = (color: string) => {
  if (color in TAG_COLOR_MAP) {
    return TAG_COLOR_MAP[color as TagColor]
  }

  Sentry.captureException(
    new Error(
      `getTagColorEntry: unknown tag color returned from the API: ${color}`,
    ),
  )

  return TAG_COLOR_MAP[DEFAULT_TAG_COLOR]
}

export const tagColorToHex = (color: TagColor): string =>
  getTagColorEntry(color).hex

export const tagColorBorder = (color: TagColor): string =>
  getTagColorEntry(color).border
